// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInMixin {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOutMixin {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.OwnedTopicsTab {
  display: flex;
  flex-direction: column;
}
.OwnedTopicsTab .filtersSection {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  margin-bottom: 24px;
}
.OwnedTopicsTab {
  margin-top: var(--spacing_unit_7);
}
.OwnedTopicsTab [class^=dist_numberSection] {
  display: none;
}
.OwnedTopicsTab [class^=dist_tableHead] th:first-child {
  display: none;
}
.OwnedTopicsTab .TableTitleWithCheckbox {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.OwnedTopicsTab .header-section {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  column-gap: var(--spacing_unit_6);
  margin-bottom: var(--spacing_unit_4);
}
.OwnedTopicsTab .header-section .header-section-item {
  display: flex;
  align-items: center;
  column-gap: var(--spacing_unit_6);
}
.OwnedTopicsTab .header-section .progressBar {
  width: 70px;
  font-size: 12px;
  color: var(--gray_dark2);
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 6px;
}
.OwnedTopicsTab .header-section .progressBar * {
  height: 2px;
}
.OwnedTopicsTab .header-section .progressBar > div {
  width: 68px;
}
.OwnedTopicsTab .header-section .progressBar span {
  height: 16px;
  width: 100%;
  white-space: nowrap;
  text-align: center;
}
.OwnedTopicsTab [class^=dist_tableBody],
.OwnedTopicsTab [class^=dist_tableHead] {
  grid-template-columns: 40px 2fr 1fr 1fr 1fr 285px !important;
}
.OwnedTopicsTab [class^=dist_tableBody] .checkboxContainer,
.OwnedTopicsTab [class^=dist_tableHead] .checkboxContainer {
  width: 26px;
  height: 20px;
  margin: 0px 8px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.OwnedTopicsTab [class^=dist_tableBody] .favoriteContainer,
.OwnedTopicsTab [class^=dist_tableHead] .favoriteContainer {
  display: none;
}
.OwnedTopicsTab [class^=dist_tableBody]:hover .favoriteContainer,
.OwnedTopicsTab [class^=dist_tableHead]:hover .favoriteContainer {
  display: inherit;
}
.OwnedTopicsTab [class^=dist_tableBody] .favoriteContainer.isActive,
.OwnedTopicsTab [class^=dist_tableBody] .favoriteContainer:has(.FavoriteButton--isSaved),
.OwnedTopicsTab [class^=dist_tableHead] .favoriteContainer.isActive,
.OwnedTopicsTab [class^=dist_tableHead] .favoriteContainer:has(.FavoriteButton--isSaved) {
  display: inherit;
}
.OwnedTopicsTab [class^=dist_tableBody] .checkboxContainer .index {
  display: inherit;
  color: var(--color_neutral_500);
  font-size: 14px;
}
.OwnedTopicsTab [class^=dist_tableBody] .checkboxContainer .TerritoryAddToCheckbox {
  display: none;
  margin: 0px;
}
.OwnedTopicsTab [class^=dist_tableBody]:hover .checkboxContainer .index {
  display: none;
}
.OwnedTopicsTab [class^=dist_tableBody]:hover .checkboxContainer .TerritoryAddToCheckbox {
  display: inherit;
}
.OwnedTopicsTab [class^=dist_tableBody] .checkboxContainer:has(.TerritoryAddToCheckbox-active) .index {
  display: none;
}
.OwnedTopicsTab [class^=dist_tableBody] .checkboxContainer:has(.TerritoryAddToCheckbox-active) .TerritoryAddToCheckbox {
  display: inherit;
}
.OwnedTopicsTab .FormatTitleTableCell {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 25% 0 0;
}
.OwnedTopicsTab .FormatTitleTableCell p {
  font-size: 14px;
  color: var(--color_neutral_800);
  margin-right: auto;
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}
.OwnedTopicsTab .FormatTitleTableCell span {
  font-size: 12px;
  color: var(--color_neutral_500);
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}
.OwnedTopicsTab .FormatCreateByTableCell {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.OwnedTopicsTab .FormatCreateByTableCell p {
  font-size: 14px;
  color: var(--color_neutral_800);
  margin-right: auto;
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}
.OwnedTopicsTab .FormatCreateByTableCell span {
  font-size: 12px;
  color: var(--color_neutral_500);
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}
.OwnedTopicsTab .FormatUploadDateTableCell {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.OwnedTopicsTab tr:hover .GenerateWinninAIReportButton-text {
  align-items: center;
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/mixins.scss","webpack://./src/modules/territory/owned-topics-tab/owned-topics-tab.styles.scss"],"names":[],"mappings":"AAwCA;EACE;IACE,UAAA;ECvCF;EDyCA;IACE,UAAA;ECvCF;AACF;AD0CA;EACE;IACE,UAAA;ECxCF;ED0CA;IACE,UAAA;ECxCF;AACF;AAbA;EACE,aAAA;EACA,sBAAA;AAeF;AAbE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;EACA,mBAAA;AAeJ;AAxBA;EAYE,iCAAA;AAeF;AAbE;EACE,aAAA;AAeJ;AAXI;EACE,aAAA;AAaN;AATE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AAWJ;AARE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,iCAAA;EACA,oCAAA;AAUJ;AARI;EACE,aAAA;EACA,mBAAA;EACA,iCAAA;AAUN;AAPI;EACE,WAAA;EACA,eAAA;EACA,wBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AASN;AAPM;EACE,WAAA;AASR;AANM;EACE,WAAA;AAQR;AALM;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AAOR;AAFE;;EAEE,4DAAA;AAIJ;AAFI;;EACE,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAKN;AAFI;;EACE,aAAA;AAKN;AADM;;EACE,gBAAA;AAIR;AAAI;;;;EAEE,gBAAA;AAIN;AAEM;EACE,gBAAA;EACA,+BAAA;EACA,eAAA;AAAR;AAGM;EACE,aAAA;EACA,WAAA;AADR;AAOQ;EACE,aAAA;AALV;AAQQ;EACE,gBAAA;AANV;AAYM;EACE,aAAA;AAVR;AAaM;EACE,gBAAA;AAXR;AAgBE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAdJ;AAgBI;EACE,eAAA;EACA,+BAAA;EACA,kBAAA;EDnJJ,oBAAA;EACA,aCmJwB;EDlJxB,qBCkJwB;EDjJxB,4BAAA;EACA,gBAAA;EACA,sBANoC;AC4ItC;AAYI;EACE,eAAA;EACA,+BAAA;EDzJJ,oBAAA;EACA,aCyJwB;EDxJxB,qBCwJwB;EDvJxB,4BAAA;EACA,gBAAA;EACA,sBANoC;ACsJtC;AASE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAPJ;AASI;EACE,eAAA;EACA,+BAAA;EACA,kBAAA;EDvKJ,oBAAA;EACA,aCuKwB;EDtKxB,qBCsKwB;EDrKxB,4BAAA;EACA,gBAAA;EACA,sBANoC;ACuKtC;AAKI;EACE,eAAA;EACA,+BAAA;ED7KJ,oBAAA;EACA,aC6KwB;ED5KxB,qBC4KwB;ED3KxB,4BAAA;EACA,gBAAA;EACA,sBANoC;ACiLtC;AAEE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAAJ;AAII;EACE,mBAAA;EACA,aAAA;AAFN","sourcesContent":["@mixin line-clamp($lines, $wordBreak: break-word) {\n  display: -webkit-box;\n  line-clamp: $lines;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: $wordBreak;\n}\n\n@mixin scrollbar(\n  $color: var(--color_neutral_200),\n  $colorHover: var(--color_neutral_400),\n  $colorActive: var(--color_neutral_500)\n) {\n  &::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $color;\n    height: 80px;\n    border-radius: 50px;\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background: $colorHover;\n    }\n  }\n\n  &::-webkit-scrollbar-thumb:active {\n    background: $colorActive;\n  }\n}\n\n@keyframes fadeInMixin {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOutMixin {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@mixin fadeIn($timing, $length, $delay, $fill) {\n  animation: fadeInMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin fadeOut($timing, $length, $delay, $fill) {\n  animation: fadeOutMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin noise {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background-image: url('./assets/images/png/noise.png');\n    background-position: 0% 0%;\n    background-size: 36.23046875px 36.23046875px;\n    background-repeat: repeat;\n    border-radius: 12px;\n    opacity: 0.3;\n  }\n}\n\n@mixin scoped-excluded($selector, $exclude-class) {\n  :is(#{$selector}):not(:where(#{$exclude-class} *)) {\n    @content;\n  }\n}\n","@import 'src/mixins.scss';\n\n.OwnedTopicsTab {\n  display: flex;\n  flex-direction: column;\n\n  .filtersSection {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-content: center;\n    margin-bottom: 24px;\n  }\n\n  margin-top: var(--spacing_unit_7);\n\n  [class^='dist_numberSection'] {\n    display: none;\n  }\n\n  [class^='dist_tableHead'] {\n    th:first-child {\n      display: none;\n    }\n  }\n\n  .TableTitleWithCheckbox {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  }\n\n  .header-section {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    column-gap: var(--spacing_unit_6);\n    margin-bottom: var(--spacing_unit_4);\n\n    .header-section-item {\n      display: flex;\n      align-items: center;\n      column-gap: var(--spacing_unit_6);\n    }\n\n    .progressBar {\n      width: 70px;\n      font-size: 12px;\n      color: var(--gray_dark2);\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      row-gap: 6px;\n\n      * {\n        height: 2px;\n      }\n\n      &>div {\n        width: 68px;\n      }\n\n      span {\n        height: 16px;\n        width: 100%;\n        white-space: nowrap;\n        text-align: center;\n      }\n    }\n  }\n\n  [class^='dist_tableBody'],\n  [class^='dist_tableHead'] {\n    grid-template-columns: 40px 2fr 1fr 1fr 1fr 285px !important;\n\n    .checkboxContainer {\n      width: 26px;\n      height: 20px;\n      margin: 0px 8px 0px 0px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .favoriteContainer {\n      display: none;\n    }\n\n    &:hover {\n      .favoriteContainer {\n        display: inherit;\n      }\n    }\n\n    .favoriteContainer.isActive,\n    .favoriteContainer:has(.FavoriteButton--isSaved) {\n      display: inherit;\n    }\n  }\n\n  [class^='dist_tableBody'] {\n    .checkboxContainer {\n      .index {\n        display: inherit;\n        color: var(--color_neutral_500);\n        font-size: 14px;\n      }\n\n      .TerritoryAddToCheckbox {\n        display: none;\n        margin: 0px;\n      }\n    }\n\n    &:hover {\n      .checkboxContainer {\n        .index {\n          display: none;\n        }\n\n        .TerritoryAddToCheckbox {\n          display: inherit;\n        }\n      }\n    }\n\n    .checkboxContainer:has(.TerritoryAddToCheckbox-active) {\n      .index {\n        display: none;\n      }\n\n      .TerritoryAddToCheckbox {\n        display: inherit;\n      }\n    }\n  }\n\n  .FormatTitleTableCell {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    padding: 0 25% 0 0;\n\n    p {\n      font-size: 14px;\n      color: var(--color_neutral_800);\n      margin-right: auto;\n      @include line-clamp(1);\n    }\n\n    span {\n      font-size: 12px;\n      color: var(--color_neutral_500);\n      @include line-clamp(1);\n    }\n  }\n\n  .FormatCreateByTableCell {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n\n    p {\n      font-size: 14px;\n      color: var(--color_neutral_800);\n      margin-right: auto;\n      @include line-clamp(1);\n    }\n\n    span {\n      font-size: 12px;\n      color: var(--color_neutral_500);\n      @include line-clamp(1);\n    }\n  }\n\n  .FormatUploadDateTableCell {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  tr:hover {\n    .GenerateWinninAIReportButton-text {\n      align-items: center;\n      display: flex;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
